import { RequestConfig } from '~/common/services/requests';
import {
  PlatformRequestOptions,
  RequestsApi,
} from '../../../../contexts/RequestsContext';

export const constructPostRequest = async <ResponseType>(
  performRequest: RequestsApi['platformRequest'],
  postPath: string,
  config?: RequestConfig,
  options?: PlatformRequestOptions,
): Promise<ResponseType | undefined> =>
  performRequest<ResponseType>(
    { method: 'POST', url: postPath, ...config },
    options,
  );
